import { isFunction, omit } from 'lodash';
import { combineReducers } from 'redux';

export const DESTROY_SCOPE = '@@DESTROY_SCOPE';

export function createScopedReducer(initialState: $TSFixMe, fnMap: $TSFixMe) {
    const isInitialStateFunction = isFunction(initialState);
    return (state = {}, { type, payload, meta: { scope } = {} }: $TSFixMe) => {
        if (type === DESTROY_SCOPE) {
            // @ts-expect-error $TSFixMeError: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{}'.
            return state[scope] ? omit(state, scope) : state;
        }

        const handler = fnMap[type];

        if (handler) {
            // @ts-expect-error $TSFixMeError: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{}'.
            let scopedState = state[scope] || (isInitialStateFunction ? initialState() : initialState);
            scopedState = handler(scopedState, payload);

            return {
                ...state,
                [scope]: scopedState,
            };
        }

        return state;
    };
}

export function combineReducersWithScope(reducers: $TSFixMe, prefix: string) {
    const reducer = combineReducers(reducers);

    return (state = {}, action: $TSFixMe) => {
        const { meta: { scope } = {}, type } = action;
        if (!scope) {
            return state;
        }

        if (type.startsWith(prefix)) {
            // @ts-expect-error $TSFixMeError: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{}'.
            const currentState = state[scope] || {};
            // @ts-expect-error $TSFixMeError: Argument of type 'any' is not assignable to parameter of type 'never'.
            const nextState = reducer(currentState, action);

            if (nextState !== currentState) {
                return {
                    ...state,
                    [scope]: nextState,
                };
            }
        }

        return state;
    };
}
